import native from '@zz-common/native-adapter'

export const isMiniprogram = () => {
  return (
    // 微信小程序
    (navigator.userAgent.match(/micromessenger/i) && navigator.userAgent.match(/miniprogram/i)) ||
    window.__wxjs_environment === 'miniprogram'
  )
}

export const enterPage = (jumpUrl, needClose) => {
  if (isMiniprogram()) {
    native.wrap('skipToUrl')({
      targetUrl: jumpUrl,
      needClose,
    })
  } else {
    native.wrap('enterUnifiedUrl')({
      unifiedUrl: jumpUrl,
    })
  }
}

export const enterOrder = (data, fromWhere = 1) => {
  const goodsList = []

  if (!data) {
    return
  }

  data.forEach((item) => {
    const { productId, infoId, num, metric } = item || {}
    if (productId) {
      goodsList.push({
        product_id: productId || '',
        infoId: infoId || '',
        num: num || 1,
        metric: metric || '',
      })
    }
  })

  let link = ''

  if (isMiniprogram()) {
    link = `/pages/order-confirm/order-confirm?goodsString=${JSON.stringify(
      goodsList
    )}&fromWhere=${fromWhere}`
  } else {
    const content = JSON.stringify({
      goodsString: JSON.stringify(goodsList),
      fromWhere,
      serviceString: '3,',
      sk: '',
    })

    link = `zljgo://native_api?type=37&content=${encodeURIComponent(content)}`
  }
  enterPage(link)
}

/**
 * v1 v2
 * @param {*} v1
 * @param {*} v2
 * @returns v1>v2 return 1   v1 == v2 return 0   v1<v2 return -1
 */
export function compareVersionPro(v1, v2) {
  if (typeof v1 != 'string' || typeof v2 != 'string') {
    return new Error('v1 v2 expected string')
  }
  const _v1Arr = v1.split('.')
  const _v2Arr = v2.split('.')
  let f = 0
  if (_v1Arr.length > _v2Arr.length) {
    f = 1
  }
  if (_v1Arr.length < _v2Arr.length) {
    f = -1
  }
  const [longArr, shortArr] = _v1Arr.length > _v2Arr.length ? [_v1Arr, _v2Arr] : [_v2Arr, _v1Arr]
  if (f != 0) {
    for (let i = 0; i < longArr.length; i++) {
      const lItem = Number(longArr[i])
      const sItem = Number(shortArr[i] || 0)
      if (lItem > sItem) {
        return f
      } else if (sItem > lItem) {
        return -f
      }
    }
  } else {
    for (let k = 0; k < _v1Arr.length; k++) {
      const _v1Item = Number(_v1Arr[k])
      const _v2Item = Number(_v2Arr[k])
      if (_v1Item > _v2Item) {
        return 1
      } else if (_v1Item < _v2Item) {
        return -1
      }
    }
  }
  return 0
}

/**
 * 获取指定 Cookie 值
 * @param {String} k 指定的 Cookie 名
 */
export const getCookie = (k) => {
  const res = RegExp('(^|; )' + encodeURIComponent(k) + '=([^;]*)').exec(document.cookie)
  return res && res[2]
}

export function copy(item) {
  return JSON.parse(JSON.stringify(item))
}

// 获取地址上的参数
export function getQueryString(name) {
  if (typeof URLSearchParams === 'function') {
    const query = new URLSearchParams(location.href)
    return query.get(name)
  } else {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i') // 定义正则表达式
    const r = location.search.substr(1).match(reg)
    if (r != null) return unescape(r[2])
  }
  return null
}
